
import { FormControl, Grid, InputLabel, IconButton, Paper, Select, makeStyles, MenuItem, TableContainer, TableHead, TableCell, Table, TableRow, TablePagination, FormControlLabel, TableBody, Switch, Button } from '@material-ui/core'
import React, { useEffect, useRef, useState } from 'react'
import moment from "moment";
import { useForm } from '../../../hooks/useForm';
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from "@material-ui/pickers";
import { REMITOS_GENERADOS, TIPO_INGRESO_MESA_ENTRADA } from '../../../utils/constants';
import { ComprobantesRemitosItem } from './ComprobantesRemitosItem';
import { AddBoxOutlined, Print } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import { generarRemitoMesaEntrada, getComprobantesDocumentoRemitos, getComprobantesRemitos } from '../../../actions/mesaEntrada/mesaEntradaActions';
import { VisualizadorRemitoMesaEntrada } from './VisualizadorRemitoMesaEntrada';


const useStyles = makeStyles({
    root: {
        padding: 10,
        flexGrow: 1,
        marginTop: 10,
        // width: "100%",
    },
    input: {
        padding: 10,
    },
    center: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
});


const stateInitial = {
    fechaDesde: moment(),
    fechaHasta: moment(),
    idRemito: null
};

export const RemitoHome = () => {

    const repo = useRef('');

    const classes = useStyles();
    const dispatch = useDispatch();
    const [
        formValues,
        ,
        ,
        setearValor,
        ,
        ,
        ,
        ,
        ,
    ] = useForm(stateInitial);
    const { fechaDesde, fechaHasta } = formValues;

    const [tipoIngreso, setTipoIngreso] = useState(1);
    const [generado, setGenerado] = useState(1);
    const [nroRemito, setNroRemito] = useState(null);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    // const [redirect, setRedirect] = useState(false);
    const [dense, setDense] = useState(true);
    const [page, setPage] = useState(0);
    const [abrirNuevoReporte, setAbrirNuevoReporte] = useState(false);

    const { remitos } = useSelector((state) => state.mesaEntrada); 
    const { areaFisicaUsuario } = useSelector((state) => state.areasFisicas);

    const componentRef = React.useRef();


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    useEffect(() => {
        if (tipoIngreso === TIPO_INGRESO_MESA_ENTRADA.PRESTADOR_PROVEEDOR) {
            dispatch(
                getComprobantesRemitos(
                    fechaDesde,
                    fechaHasta,
                    tipoIngreso,
                    generado,
                    areaFisicaUsuario.idArea,
                    areaFisicaUsuario.idSubArea
                )
            );
        }
        if (tipoIngreso === TIPO_INGRESO_MESA_ENTRADA.DOCUMENTACION) {
            dispatch(
                getComprobantesDocumentoRemitos(
                    fechaDesde,
                    fechaHasta,
                    tipoIngreso,
                    generado,
                    areaFisicaUsuario.idArea,
                    areaFisicaUsuario.idSubArea
                )
            );
        }
    }, [dispatch, tipoIngreso, generado, fechaDesde, fechaHasta, nroRemito]);

    const generarRemito = () => {
        setNroRemito(null);
        const data = {
            fechaDesde: fechaDesde,
            fechaHasta: fechaHasta,
            idTipoIngreso: tipoIngreso,
            generado: generado,
            idArea: areaFisicaUsuario.idArea,
            idSubArea: areaFisicaUsuario.idSubArea
        }
        dispatch(generarRemitoMesaEntrada(data, nroRemito, setNroRemito))
    }

    const imprimirRemito = () => {
        repo.current = 'remito';
        setAbrirNuevoReporte(true);
    }

    console.log(nroRemito)
    return (
        <div className={classes.root}>
            <VisualizadorRemitoMesaEntrada abrirModal={abrirNuevoReporte} setAbrirModal={setAbrirNuevoReporte} reporte={repo.current} tipoIngreso={tipoIngreso}/>
            <Grid
                container
                spacing={1}
                direction="row"
                justify="center"
                alignItems="center"
            >
                <Grid item xs={12} styles={{ padding: 5 }}>
                    <Grid container direction="row" alignItems="center" spacing={1}>
                        <Grid item xs={12} md={2}>
                            <Paper className={classes.input}>
                                <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        label="Fecha Desde"
                                        format="dd/MM/yyyy"
                                        required={true}
                                        clearLabel="Limpiar"
                                        cancelLabel="Cancelar"
                                        maxDate={fechaHasta}
                                        maxDateMessage={`La fecha no puede ser posterior a la fecha Hasta`}
                                        value={moment(fechaDesde).isValid()
                                            ? moment(fechaDesde)
                                            : null}
                                        onChange={(date) => {
                                            setearValor("fechaDesde", date);
                                        }}
                                        KeyboardButtonProps={{
                                            "aria-label": "change date",
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <Paper className={classes.input}>
                                <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        label="Fecha Hasta"
                                        format="dd/MM/yyyy"
                                        required={true}
                                        clearLabel="Limpiar"
                                        cancelLabel="Cancelar"
                                        minDate={fechaDesde}
                                        minDateMessage={`La fecha no puede ser anterior a la fecha de Desde`}
                                        value={moment(fechaHasta).isValid()
                                            ? moment(fechaHasta)
                                            : null}
                                        onChange={(date) => {
                                            setearValor("fechaHasta", date);
                                        }}
                                        KeyboardButtonProps={{
                                            "aria-label": "change date",
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <Paper className={classes.input} style={{ padding: 23 }}>
                                <FormControl fullWidth>
                                    <InputLabel id="select-parentesco-label">¿Generado?</InputLabel>
                                    <Select
                                        style={{ marginTop: 13 }}
                                        value={generado}
                                        labelId="select-seccional-label"
                                        onChange={(e) => setGenerado(e.target.value)}
                                    >
                                        <MenuItem value={REMITOS_GENERADOS.SIN_GENERAR}>Sin Generar</MenuItem>
                                        <MenuItem value={REMITOS_GENERADOS.GENERADOS}>Generados</MenuItem>
                                    </Select>
                                </FormControl>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <Paper className={classes.input} style={{ padding: 23 }}>
                                <FormControl fullWidth>
                                    <InputLabel id="select-parentesco-label">Tipo de Ingreso</InputLabel>
                                    <Select
                                        style={{ marginTop: 13 }}
                                        value={tipoIngreso}
                                        labelId="select-seccional-label"
                                        onChange={(e) => setTipoIngreso(e.target.value)}
                                    >
                                        <MenuItem value={TIPO_INGRESO_MESA_ENTRADA.PRESTADOR_PROVEEDOR}>Prestador/Proveedor</MenuItem>
                                        <MenuItem value={TIPO_INGRESO_MESA_ENTRADA.DOCUMENTACION}>Documentación</MenuItem>
                                    </Select>
                                </FormControl>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Paper className={classes.input} style={{ padding: 12 }}>
                                <div
                                    style={{
                                        margin: '0.2rem 0',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-evenly',
                                    }}
                                >
                                    <Button variant="contained"
                                        color="primary"
                                        disabled={generado === REMITOS_GENERADOS.SIN_GENERAR ? false : true}
                                        onClick={generarRemito}
                                    >
                                        <IconButton>
                                            <AddBoxOutlined />
                                        </IconButton>
                                        Generar Remito
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        disabled={false}
                                        onClick={imprimirRemito}
                                    >
                                        <IconButton>
                                            <Print />
                                        </IconButton>
                                        Imprimir Remito
                                    </Button>
                                </div>
                            </Paper>
                        </Grid>
                    </Grid>
                </Grid>


                <Grid item xs={12}>
                    <TableContainer component={Paper} style={{ overflowX: "auto" }}>
                        <Table size={dense ? "small" : "medium"} ref={componentRef}>
                            <TableHead>
                                {tipoIngreso === TIPO_INGRESO_MESA_ENTRADA.PRESTADOR_PROVEEDOR && (
                                    <TableRow>
                                        <TableCell align="left">Estado</TableCell>
                                        <TableCell align="left">Id Comprobante</TableCell>
                                        <TableCell align="left">Id Comprobante SV</TableCell>
                                        <TableCell align="left">Fecha Recepción</TableCell>
                                        <TableCell align="left">Prestadores</TableCell>
                                        <TableCell align="left">Tipo Comprobante</TableCell>
                                        <TableCell align="left">N° Comprobante</TableCell>
                                        <TableCell align="left">Total Comprobante</TableCell>
                                        <TableCell align="left">Destino</TableCell>
                                        <TableCell align="left">Nro Remito</TableCell>
                                    </TableRow>
                                )}
                                {tipoIngreso === TIPO_INGRESO_MESA_ENTRADA.DOCUMENTACION && (
                                    <TableRow>
                                        <TableCell align="left">Estado</TableCell>
                                        <TableCell align="left">Id Comprobante</TableCell>
                                        <TableCell align="left">Id Comprobante SV</TableCell>
                                        <TableCell align="left">Fecha Recepción</TableCell>
                                        <TableCell align="left">Fecha Carta</TableCell>
                                        <TableCell align="left">Caratula</TableCell>
                                        <TableCell align="left">Entregado Por</TableCell>
                                        <TableCell align="left">Folios</TableCell>
                                        <TableCell align="left">Destino</TableCell>
                                        <TableCell align="left">Nro Remito</TableCell>
                                    </TableRow>
                                )}
                            </TableHead>
                            <TableBody>
                                {remitos.length > 0 && (
                                    remitos.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((item, index) => {
                                            return (
                                                <ComprobantesRemitosItem
                                                    item={item}
                                                    fechaDesde={fechaDesde}
                                                    fechaHasta={fechaHasta}
                                                    key={remitos.idComprobante}
                                                    labelId={`enhanced-table-checkbox-${index}`}
                                                    tipoIngreso={tipoIngreso}
                                                />
                                            );
                                        }))}
                                {remitos.length === 0 && (
                                    <TableRow style={{ height: 50 }}>
                                        <TableCell
                                            colSpan={13}
                                            style={{ textAlign: "-webkit-center" }}
                                        >
                                            {" "}
                                            Sin Registros
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
                {remitos.length > 0 && (
                    <Grid item xs={12}>
                        <TablePagination
                            style={{ backgroundColor: "white" }}
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={remitos.length}
                            rowsPerPage={rowsPerPage}
                            labelRowsPerPage="Registros por página"
                            page={page}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={dense}
                                    onChange={(e) => setDense(e.target.checked)}
                                />
                            }
                            label="Tamaño compacto"
                        />
                    </Grid>
                )}
            </Grid>
        </div>
    )
}
